<template>
  <div class="smsMfaSetting">
    <account-header />
    <v-divider class="smsMfaSetting_divider" />
    <h3 class="smsMfaSetting_title">
      認証コードを送信する電話番号を設定してください。
    </h3>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <section class="smsMfaSetting_content">
        <section class="smsMfaSetting_input">
          <h4 class="smsMfaSetting_item">国/地域を選択してください</h4>
          <country-code
            :default-code="countryCode"
            outlined
            @select="handleSelectCountry"
          ></country-code>
        </section>

        <ValidationProvider
          v-slot="{ errors }"
          vid="phoneInput"
          name="電話番号"
          rules="required"
          class="smsMfaSetting_input"
        >
          <h4
            class="smsMfaSetting_item"
            :class="{ ['smsMfaSetting_item--error']: errors.length }"
          >
            電話番号を入力してください
          </h4>

          <v-text-field
            v-model="phoneInput"
            maxlength="11"
            required
            class="smsMfaSetting_container_input"
            :error-messages="errors"
            color="dark"
            full-width
            placeholder="00011112222"
            persistent-hint
            hint="半角数字、ハイフンなしで入力してください。"
            outlined
          />
        </ValidationProvider>
      </section>
      <article class="smsMfaSetting_desc">
        電話番号はアカウントのセキュリティの為に使用されます。標準の電話料金とSMS料金が適用されます。
      </article>
      <div class="smsMfaSetting_action">
        <v-btn
          class="smsMfaSetting_btn-submit"
          :disabled="invalid"
          :loading="submitLoading"
          @click="handleSubmit"
        >
          セキュリティ設定を保存する
        </v-btn>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { authService } from '@/services/auth.service';
import AccountHeader from '../AccountHeader.vue';
import parsePhoneNumber from 'libphonenumber-js';

export default {
  name: 'SmsMfaSetting',
  components: {
    AccountHeader,
  },
  data() {
    return {
      submitLoading: false,
      countryCode: '+81',
      phoneInput: '',
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async handleSubmit() {
      try {
        this.submitLoading = true;
        const newPhoneNumber = this.countryCode + this.phoneInput;
        await authService.updateUserPhone(newPhoneNumber);
        await authService.setMFA('SMS');
        this.$router.push({ name: 'account-mfa' });
      } catch (error) {
        console.error(error);
      } finally {
        this.submitLoading = false;
      }
    },
    async init() {
      const phoneNumber = await authService.getUserPhone();
      if (phoneNumber) {
        const parsedPhoneNumber = parsePhoneNumber(phoneNumber);
        this.countryCode = '+' + parsedPhoneNumber.countryCallingCode;
        this.phoneInput = parsedPhoneNumber.nationalNumber;
      }
    },
    handleSelectCountry(e) {
      this.countryCode = e.code;
    },
  },
};
</script>

<style lang="scss">
.smsMfaSetting {
  overflow: auto;
  height: 100%;

  &_title {
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #4b4b4b;
    margin-top: 16px;
  }

  &_item {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #666;
    margin: 10px 0;
  }
  &_desc {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #989898;
    margin-bottom: 15px;
  }

  &_container {
    display: flex;
    flex-direction: column;
    &_item {
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      height: 16px;
      color: #333333;
      &--error {
        color: var(--v-error-base);
      }
    }
    &_input {
      margin-bottom: 0;
      margin-top: 0;
      padding-top: 0;
      width: 295px;
      &.v-input {
        font-size: 18px;
        .v-messages:not(.error--text) {
          .v-messages__message {
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: left;
            color: #989898;
          }
        }
      }
      .v-text-field__slot {
        padding-left: 0;
      }
      .v-input__slot {
        min-height: 40px !important;
        .v-message__message {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: left;
          color: #989898;
        }
      }
      input {
        line-height: 32px !important;
        color: var(--text-color) !important;
        font-size: 18px !important;
        font-weight: normal !important;
        font-stretch: normal !important;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        &:-webkit-autofill,
        &:-webkit-autofill::first-line {
          font-family: 'Noto Sans JP', sans-serif;
          font-size: 18px;
          font-weight: 500;
        }
      }

      .v-text-field__details {
        padding: 0 !important;
        padding-top: 0px !important;
        margin-bottom: 0 !important;
      }
    }
  }

  &_input {
    margin-top: 4px;
    &-label {
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.7px;
      text-align: left;
      color: var(--text-color-2);
      margin-right: 20px;
    }
    &-code {
      &.v-text-field {
        max-width: 168px;
        font-size: 40px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 2px;
        text-align: center;
        color: var(--text-color);
        &.theme--light.v-input input {
          max-width: 168px;
          max-height: 70px;
          text-align: center;
        }
      }
    }
  }
  &_divider {
    margin-top: 16px;
    &.theme--light.v-divider {
      border-color: #ccc;
    }
  }
  &_gap-header {
    height: 26px;
  }
  &_action {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    padding: 15px 0;
    h3 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
  }
  &_btn {
    &-submit {
      &.theme--light.v-btn.v-btn--has-bg {
        height: 36px;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        background-color: #0075c2;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: normal;
        text-align: left;
        color: #fff;
      }
      &.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
        background-color: #f3f3f3 !important;
        box-shadow: none;
        color: #ccc !important;
      }
    }
  }
}
</style>
